
import { defineComponent, computed } from 'vue'
import type { MetaInfo } from 'vue-meta'

import { UserPermission } from '@/types'
import { useViewer } from '@/use'
import GlobalLoading from '@/plugins/loading/components/GlobalLoading.vue'
import AppSidebar from '@/components/Sidebar/Sidebar.vue'
import AppNavigation from '@/components/AppNavigation/AppNavigation.vue'
import LastRoom from '@/components/LastRoom/LastRoom.vue'
import RecentlyViewedRooms from '@/components/RecentlyViewedRooms/RecentlyViewedRooms.vue'

export default defineComponent({
  name: 'App',
  components: {
    GlobalLoading,
    AppSidebar,
    AppNavigation,
    LastRoom,
    RecentlyViewedRooms,
  },
  setup() {
    const { viewer } = useViewer()
    const isSidebarVisible = computed(
      () =>
        viewer.value !== null &&
        (viewer.value.permission === UserPermission.ADMIN ||
          viewer.value.permission === UserPermission.STAFF)
    )
    return { isSidebarVisible }
  },
  metaInfo(): MetaInfo {
    return {
      titleTemplate: (titleChunk) => {
        return titleChunk !== ''
          ? `${titleChunk} - Content Tools`
          : 'Content Tools'
      },
    }
  },
})
